/* KEYP motion engine. Added 2026-09-25. Own file: theme updates never touch it.
   Usage (attributes on any element inside a .lx section):
     data-lx="fade"      fade + rise on enter (default for .lx-reveal too)
     data-lx="clip"      wipe-reveal from the bottom, inner image settles from a slight zoom
     data-lx="stagger"   children rise one after another (data-lx-stagger="90" ms between)
     data-lx="words"     heading rises word by word
     data-lx="count"     number counts up: data-lx-to="4.7" data-lx-decimals="1" data-lx-prefix data-lx-suffix
     data-lx="stars"     gold star fill animates to data-lx-to (out of 5)
     data-lx="bar"       .lx-bar__fill grows to --lx-to
     data-lx-parallax="0.18"  element drifts on scroll (desktop only), pair with an overflow:hidden parent
   Everything resolves to its final state instantly when the user prefers reduced motion. */
(function () {
  if (window.__lxMotion) return;
  window.__lxMotion = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  var easeOut = function (t) { return 1 - Math.pow(1 - t, 3); };

  function splitWords(el) {
    if (el.getAttribute('data-lx-split')) return;
    el.setAttribute('data-lx-split', '1');
    var text = el.textContent;
    el.textContent = '';
    var parts = text.split(/(\s+)/), i = 0;
    parts.forEach(function (w) {
      if (!w.trim()) { el.appendChild(document.createTextNode(w)); return; }
      var outer = document.createElement('span'); outer.className = 'lx-w';
      var inner = document.createElement('span'); inner.textContent = w;
      inner.style.transitionDelay = (i * 50) + 'ms';
      outer.appendChild(inner); el.appendChild(outer); i++;
    });
  }

  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-lx-to') || '0');
    var dec = parseInt(el.getAttribute('data-lx-decimals') || '0', 10);
    var pre = el.getAttribute('data-lx-prefix') || '', suf = el.getAttribute('data-lx-suffix') || '';
    var dur = parseInt(el.getAttribute('data-lx-duration') || '1250', 10);
    var fmt = function (n) { var s = n.toFixed(dec); if (dec === 0 && n >= 1000) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); return pre + s + suf; };
    if (reduce) { el.textContent = fmt(to); return; }
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      el.textContent = fmt(to * easeOut(p));
      if (p < 1) raf(step);
    }
    raf(step);
  }

  function stars(el) {
    var to = parseFloat(el.getAttribute('data-lx-to') || '5');
    var pct = Math.max(0, Math.min(100, (to / 5) * 100));
    el.style.setProperty('--lx-stars', pct + '%');
  }

  function stagger(el) {
    var gap = Math.round(parseInt(el.getAttribute('data-lx-stagger') || '90', 10) * 0.75);
    Array.prototype.forEach.call(el.children, function (c, i) { c.style.transitionDelay = (i * gap) + 'ms'; });
  }

  function enter(el) {
    var kind = el.getAttribute('data-lx');
    if (kind === 'count') countUp(el);
    if (kind === 'stars') stars(el);
    el.classList.add('is-in');
  }

  function prime(el) {
    var kind = el.getAttribute('data-lx');
    if (kind === 'words') splitWords(el);
    if (kind === 'stagger') stagger(el);
  }

  var observer = null;
  function observe(root) {
    var els = (root || document).querySelectorAll('[data-lx]:not(.is-in), .lx-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (e) { prime(e); enter(e); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { enter(en.target); observer.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -4% 0px', threshold: 0.06 });
    }
    Array.prototype.forEach.call(els, function (e) { prime(e); observer.observe(e); });
  }

  // parallax: desktop only, cheap transform on scroll
  var pItems = [], ticking = false;
  function collectParallax(root) {
    var els = (root || document).querySelectorAll('[data-lx-parallax]');
    Array.prototype.forEach.call(els, function (e) { if (pItems.indexOf(e) === -1) pItems.push(e); });
  }
  function updateParallax() {
    if (reduce || window.innerWidth < 768) { pItems.forEach(function (e) { e.style.transform = ''; }); return; }
    var vh = window.innerHeight;
    pItems.forEach(function (e) {
      var r = e.parentElement.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      var f = parseFloat(e.getAttribute('data-lx-parallax') || '0.15');
      var center = r.top + r.height / 2 - vh / 2;
      e.style.transform = 'translate3d(0,' + (center * f * -1).toFixed(1) + 'px,0)';
    });
  }
  // scroll-reveal hero: --s (video shrinks into a window) and --c (content arrives), 0..1
  var heroes = [];
  var smooth = function (t) { return t * t * (3 - 2 * t); };
  function collectHeroes(root) {
    var els = (root || document).querySelectorAll('[data-lx-hero].lx-hero--pin');
    Array.prototype.forEach.call(els, function (e) { if (heroes.indexOf(e) === -1) heroes.push(e); });
  }
  function updateHeroes() {
    var vh = window.innerHeight;
    heroes.forEach(function (h) {
      var track = h.querySelector('.lx-hero__track');
      if (!track) return;
      var range = track.offsetHeight - vh;
      var p = range > 0 ? Math.min(1, Math.max(0, -track.getBoundingClientRect().top / range)) : 1;
      var s = 0;
      var c = smooth(Math.min(1, Math.max(0, (p - 0.06) / 0.44)));
      h.style.setProperty('--s', s.toFixed(4));
      h.style.setProperty('--c', c.toFixed(4));
      h.classList.toggle('is-revealed', c > 0.05);
    });
  }

  function onScroll() { if (!ticking) { ticking = true; raf(function () { ticking = false; updateParallax(); updateHeroes(); }); } }

  function init(root) {
    observe(root);
    collectParallax(root);
    collectHeroes(root);
    updateParallax();
    updateHeroes();
  }

  // photos should be ready before the shopper reaches them (2026-09-26): once the page has loaded,
  // switch lazy images to eager a few at a time, and widen the theme's lazysizes look-ahead.
  function warmImages() {
    if (window.lazySizes && window.lazySizes.cfg) { window.lazySizes.cfg.expand = 1800; window.lazySizes.cfg.expFactor = 3; }
    var imgs = Array.prototype.slice.call(document.querySelectorAll('img[loading="lazy"]'));
    var i = 0;
    (function next() {
      imgs.slice(i, i + 6).forEach(function (img) { img.loading = 'eager'; });
      i += 6;
      if (i < imgs.length) setTimeout(next, 120);
    })();
  }
  var idleCb = window.requestIdleCallback || function (f) { return setTimeout(f, 250); };
  if (document.readyState === 'complete') idleCb(warmImages); else window.addEventListener('load', function () { idleCb(warmImages); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
